import { render, staticRenderFns } from "./AttendanceGroup.vue?vue&type=template&id=36f8b74e&scoped=true"
import script from "./AttendanceGroup.vue?vue&type=script&lang=js"
export * from "./AttendanceGroup.vue?vue&type=script&lang=js"
import style0 from "./AttendanceGroup.vue?vue&type=style&index=0&id=36f8b74e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8b74e",
  null
  
)

export default component.exports